<template>
  <form id="kt_user_others" @submit.prevent="updateEmployeFolder" class="form" action="#">

    <div class="card-header border-0" v-if="!route.params.id">
      <div class="card-title">
        <h2 class="fw-bolder mb-0">{{ $t('folder.fiche_employe') }}</h2>
      </div>
      <div class="card-toolbar">
        <Button btn-class="btn-sm" v-if="$can(true)" type="new" btn-text="button.save" @click.prevent="updateEmployeFolder" :isLoading="isLoading"/>
      </div>
    </div>

    <div class="card-body" >
      <RequiredText />
      <div class="row mb-5">
        <Select2
            v-if="!isEdit"
          containerClass="col-4 col-md-6 col-sm-12 mb-5"
          name="user"
          :label="$t('folder.user')"
          :multiple="false"
          :isRequired="true"
          v-model="formData.user_id">
          <option v-for="user in users" :key="user.id" :value="user.id">{{ user?.lastname }}   {{ user?.firstname }}</option>                
        </Select2>
      
        <Input
          :name="`lastname`"
          :label="$t('user.lastname')"
          :isRequired="true" size="lg"
          containerClass="col-4 col-md-6 col-sm-12 mb-5"
          v-model="formData.lastname"
        />                                              
      
        <Input
          :name="`firstname`"
          :label="$t('user.firstname')"
          :isRequired="true" size="lg"
          containerClass="col-4 col-md-6 col-sm-12 mb-5"
          v-model="formData.firstname"
        /> 
    
        <InputTel
          name="newUserPhone"
          type="text"
          :label="$t('user.phone')"
          containerClass="col-4 col-md-6 col-sm-12 mb-5"
          v-model:phone="formData.phone"
          v-model:phone-code="formData.phone_code"
          :placeholder="$t('enter_phone')"
          :isRequired="false" />
        <InputDate
          :name="`birthday`"
          :label="$t('user.label.birthday')"
          :isRequired="false" size="lg"
          containerClass="col-4 col-md-6 col-sm-12 mb-5"
          v-model="formData.birthday"
        />  
        <Select2
          :name="`employee_family_status_id`"
          containerClass="col-4 col-md-6 col-sm-12 mb-5"
          :multiple="false"
          :show-search="true"
          :label="$t('user.label.family')"
          :placeholderText="$t('user.label.family')"
          v-model="formData.employee_family_status_id"
          :IsInputGroup="true"
          :is-required="false"
          icon="bi bi-plus"
          :clickAddon="openMaritalModal">
        <option v-for="statut in status" :key="statut.id" :value="statut.id">
          {{ statut.title }}
        </option>
      </Select2>

      <Input
          :name="`address`"
          :label="$t('user.label.address')"
          :isRequired="false" size="lg"
          containerClass="col-4 col-md-6 col-sm-12 mb-5"
          v-model="formData.address"
      />
     
      <Select2
        containerClass="col-4 col-md-6 col-sm-12 mb-5"
        :multiple="false"
        :show-search="true"
        :name="`nationality`"
        :label="$t('folder.nationality')"
        v-model="formData.nationality_id"
        :isRequired="true"
       >
        <option value=""></option>
        <option v-for="nationality in nationalities" :key="nationality.id" :value="nationality.id">{{  nationality['name_'+locale]}}</option>
      </Select2>
      <Input
          :name="`social_security_number`"
          :label="$t('user.label.securityNumber')"
          :isRequired="false" size="lg"
          containerClass="col-4 col-md-6 col-sm-12 mb-5"
          v-model="formData.social_security_number"
      />
      <Select2
        :name="`employee_post_category_id`"
        containerClass="col-4 col-md-6 col-sm-12 mb-5"
        :multiple="false"
        :show-search="true"
        :label="$t('user.label.category')"
        :placeholderText="$t('user.label.category')"
        v-model="formData.employee_post_category_id"
        :IsInputGroup="true"
        :is-required="false"
        icon="bi bi-plus"
        :clickAddon="openCategoryModal">
      <option v-for="category in categories" :key="category.id" :value="category.id">
        {{ category.title }}
      </option>
    </Select2>
    <InputDate
        :name="`date_in_service`"
        :label="$t('user.label.entry_date')"
        :isRequired="false" size="lg"
        containerClass="col-4 col-md-6 col-sm-12 mb-5"
        v-model="formData.date_in_service"
    />  
    <Select2
      containerClass="col-4 col-md-6 col-sm-12 mb-5"
      :multiple="false"
      :show-search="true"
      :name="`employe_department`"
      :label="$t('user.department')"
      v-model="formData.department_id"
      :IsInputGroup="true"
      :isRequired="false"
      icon="bi bi-plus"
      :clickAddon="openCreateDepartmentModal">
      <option value="">{{ $t('user.department_placeholder') }}</option>
      <option v-for="department in departments" :key="department.id" :value="department.id">{{ department?.name }}</option>
    </Select2>
    <Select2
      containerClass="col-4 col-md-6 col-sm-12 mb-5"
      :multiple="false"
      :show-search="true"
      :name="`post`"
      :label="$t('user.post')"
      v-model="formData.post_id"
      :IsInputGroup="true"
      :isRequired="false"
      icon="bi bi-plus"
      :clickAddon="openCreatePostModal">
      <option value="">{{ $t('user.post_placeholder') }}</option>
      <option v-for="post in posts" :key="post.id" :value="post.id">{{ post?.title }}</option>
    </Select2>
    <Input
        v-if="!isEdit"
        :name="`nbrHolidays`"
        :label="$t('user.label.nbrHolidays')"
        :isRequired="false" size="lg"
        type="number"
        containerClass="col-4 col-md-6 col-sm-12 mb-5"
        v-model="formData.nbrHolidays"
    />
      </div>
      
      <div class="separator mb-6"></div>
      <div style="float: right;" class="mb-5">
        <Button btn-class="btn-sm" type="new" btn-text="button.save" @click.prevent="updateEmployeFolder" :isLoading="isLoading"/>
      </div>
    </div>
  </form>
  <CreateDepartmentForm
      id="department"
      @reloadDepartments="handleCreatedDepartment" />
  <CreatePostForm id="kt_modal_post" @postOffice="handleCreatedPost" />
  <CreateCategorieModal  id="categoryCreateModal"  @load="loadCategory" @addType="selectedCategory"></CreateCategorieModal>
  <CreateMaritalModal id="maritalCreateModal" @load="loadMarital" @addType="selectedMarital"></CreateMaritalModal>
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import { useRouter, useRoute } from 'vue-router'
import {useStore} from "vuex";
import Select2 from "@/components/Select2.vue";
import RequiredText from "@/components/RequiredText.vue"
import Button from "@/components/Button.vue"
import InputDate from "@/components/InputDate.vue";
import InputTel from "@/components/InputTel.vue";
import Input from "@/components/Input.vue";
import CreatePostForm from '@/components/Post/postModal.vue'
import CreateDepartmentForm from '@/components/department/Create.vue'
import CreateCategorieModal from "@/components/Categories/CreateCategorieModal.vue";
import CreateMaritalModal from "@/components/Marital/CreateMaritalModal.vue";
import { useLocales } from "@/composables/locales";

const route = useRoute()
const router = useRouter()
const store = useStore()
const {locale} = useLocales()

const props = defineProps({
  form: {
    type: Object,
    default: {
      user_id: "",
      lastname: "",
      firstname: "",
      phone_code: "",
      phone: "",
      department_id: "",
      post_id: "",
      birthday: "" ,
      address: "" ,
      date_in_service: "" ,
      social_security_number: "" ,
      employee_family_status_id: "",
      employee_post_category_id: "" ,
      nationality_id: "",
      nbrHolidays: "" 
    }
  },
  isEdit : {
    type : Boolean,
    default : false
  }
})

const isLoading = ref(false)
const formData = ref(props.form)

const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])
const users = computed(()=> store.getters['offices/getEmployees'])
const status = computed(() => store.getters['user/getFamilyStatus'])
const categories = computed(() => store.getters['user/getPostCategories'])
const departments = computed(() => store.getters['department/getDepartments'])
const posts = computed(() => store.getters['post/getPost'])
const nationalities = computed(() => store.getters['employes/getNationalities'])

watch(() => currentSociety.value, () => {
  fetchEmployees()
})

watch(() => props.form, () => {
  formData.value = {...props.form}
})

watch(() => formData.value.user_id, () => {
  let user = users.value?.filter(el => el.id === formData.value.user_id)[0]

  formData.value.lastname = user.lastname
  formData.value.firstname = user.firstname
  formData.value.phone_code = user.phone_code?.toString()
  formData.value.phone = user.phone?.toString()
  formData.value.post_id = user.post_id
  formData.value.department_id = user.department_id
  formData.value.birthday = user.birthday
  formData.value.address = user.address
  formData.value.date_in_service = user.date_in_service
  formData.value.social_security_number = user.social_security_number
  formData.value.employee_family_status_id = user.employee_family_status_id
  formData.value.employee_post_category_id = user.employee_post_category_id
  formData.value.nbrHolidays = user.nbrHolidays
})

async function updateEmployeFolder(){
  let response = {}

  isLoading.value = true

  try{
    response = await store.dispatch('employes/createOrUpdateEmployeFolder',formData.value)
    window.toastr['success'](i18n.global.t("notification.folder_setup"))
    isLoading.value = false
    router.push({name: "employe-folder-list"})
    return true

  }catch(err){
    isLoading.value = false
  }
}

function openCreateDepartmentModal () {
  $('#kt_modal_department').modal('toggle')
}

function handleCreatedPost(id){
  formData.value.post_id = id
}

function openCreatePostModal () {
  $('#kt_modal_post').modal('toggle')
}


function handleCreatedDepartment (id) {
  formData.value.department_id = id
}

function openMaritalModal() {
  $('#maritalCreateModal').modal('toggle');
}

function openCategoryModal() {
  $('#categoryCreateModal').modal('toggle');
}

function selectedCategory(id){
  formData.value.employee_post_category_id = id
}

function selectedMarital(id){
  formData.value.employee_family_status_id = id
}

function loadMarital(){
  store.dispatch('user/loadFamilyStatus')
}

function loadCategory(){
  store.dispatch('user/loadPostCategories')
}

function loadData() {
  Promise.all([
    store.dispatch('department/loadDepartments'),
    store.dispatch('post/loadPosts'),
    store.dispatch('employes/loadNationalities'),
    fetchEmployees()
  ])
}

const fetchEmployees = ()=>{
  if(currentSociety.value){
    store.dispatch("offices/loadSocietyEmployee", currentSociety.value?.id)
  }
}


onMounted(() => {
  loadData()
  loadMarital()
  loadCategory()
})
</script>
